<template>
    <div class="book-keeping-container">
        <cloud-layout
            type="BK"
            @onClickSubmit="onAsk"
            name="代理记账服务"
        >
            <product-nav slot="nav" current-label="代理记账服务"></product-nav>
            <product-buy
                slot="buy"
                :base-info="baseInfo"
                :adding="adding"
                type="bookkeeping"
                @buy="onBuy"
                @ask="onAsk"
                @shopping="addShoppingCart"
            >
                <div
                    slot="form"
                    class="form-data-container"
                >
                    <div class="form-item">
                        <div class="form-label">服务地区：</div>
                        <div class="form-content">
                            <el-select
                                v-model="formdata.selectedRegionCode"
                                :filterable="true"
                                size="small"
                                @change="onRegionChange"
                            >
                                <el-option-group
                                    v-for="group in regionDatasource"
                                    :key="group.label"
                                    :label="group.label"
                                >
                                    <el-option
                                        v-for="item in group.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-option-group>
                            </el-select>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">纳税人类型：</div>
                        <div class="form-content">
                            <div
                                v-for="item in taxpayerTypeDataSource"
                                :key="item.value"
                                :class="['select-item', item.value === formdata.selectedTaxpayerType
                                    ? 'be-selected' : '']"
                                @click="onSelect('taxpayerType', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === formdata.selectedTaxpayerType"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">年开票额：</div>
                        <div class="form-content">
                            <div
                                v-for="item in invoiceAmountDataSource"
                                :key="item.value"
                                :class="['select-item', item.value === formdata.selectedInvoiceAmount
                                    ? 'be-selected' : '']"
                                @click="onSelect('invoiceAmount', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === formdata.selectedInvoiceAmount"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">服务时长：</div>
                        <div class="form-content">
                            <div
                                v-for="item in serviceTimeDataSource"
                                :key="item.value"
                                :class="['select-item', item.value === selectedServiceTime ? 'be-selected' : '']"
                                @click="onSelect('serviceTime', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === selectedServiceTime"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div v-if="judgmentTime" class="form-item">
                        <div class="form-label">限时活动：</div>
                        <div class="form-activity-content">
                            {{ baseInfo.activityContent }}
                        </div>
                    </div>
                </div>
            </product-buy>
            <product-intro slot="intro" type="BKP">
                <div
                    slot="content"
                    class="product-info-content book-keeping-content"
                >
                    <div class="info-item-content book-title-content">
                        <h2 class="book-intro-title">服务介绍</h2>
                        <p
                            class="book-intro-des"
                        >{{ bookInfoDesc }}</p>
                        <div class="book-intro">
                            <div
                                v-for="(item, index) in intro"
                                :key="index"
                                class="book-intro-item"
                            >
                                <img :src="item.icon"/>
                                <p>{{ item.text }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="info-item-content book-title-content">
                        <h2 class="content-title">服务内容</h2>
                        <div class="book-content">
                            <div class="book-content-left">
                                <div
                                    v-for="(item, index) in serviceContent"
                                    :key="index"
                                    class="book-content-item"
                                >
                                    <div class="bk-icon"></div>
                                    <div class="bk-text">{{ item }}</div>
                                </div>
                            </div>
                            <div class="book-content-img"></div>
                        </div>
                    </div>
                    <div class="info-item-content advantage-content">
                        <h2 class="advantage-title">服务优势</h2>
                        <div class="book-advantage">
                            <div
                                v-for="(item, index) in advantage"
                                :key="index"
                                class="book-advantage-item"
                            >
                                <img :src="item.icon"/>
                                <div class="book-advantage-text">
                                    <h4>{{ item.title }}</h4>
                                    <p>{{ item.des }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-item-content process-content">
                        <h2 class="process-title">办理流程</h2>
                        <img
                            class="process-icon"
                            src="../assets/book_liucheng.png"
                        />
                    </div>
                    <div class="info-item-content materials-content">
                        <h2 class="materials-title">办理材料</h2>
                        <div class="book-materials">
                            <div
                                v-for="(item, index) in materials"
                                :key="index"
                                class="book-advantage-item"
                            >
                                <img :src="item.icon"/>
                                <h4>{{ item.title }}</h4>
                                <div class="materials-text">
                                    <p
                                        v-for="(desItem, index) in item.des"
                                        :key="index"
                                    >{{ desItem }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-item-content problem-content">
                        <h2 class="problem-title">常见问题</h2>
                        <img
                            class="problem-icon"
                            src="../assets/problem_icon.png"
                        />
                        <div class="problem-item-content">
                            <div
                                v-for="(item, index) in problem"
                                :key="index"
                                class="problem-item"
                            >
                                <h4>{{ item.title }}</h4>
                                <p>{{ item.des }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </product-intro>
        </cloud-layout>

        <verify-user-phone
            v-if="openPhoneDialog"
            :protocol="protocol"
            :saved-phone="userPhone"
            @saveUserPhone="saveUserPhone"
            @onClose="onClosePhoneDialog"
            @onSubmit="skipToOrderPage"
        ></verify-user-phone>

        <submit-dialog
            v-if="showSubmitDialog"
            type="BK"
            title="代理记账服务"
            :area="formdata.selectedRegionCode"
            @close="onClose"
        ></submit-dialog>
    </div>
</template>

<script>
import {Message} from 'element-ui';
import CloudLayout from '../components/CloudLayout.vue';
import ProductBuy from '../components/NewProductBuy.vue';
import ProductIntro from '../components/ProductIntro.vue';
import VerifyUserPhone from '../components/VerifyUserPhone.vue';
import ProductNav from '../components/ProductNav.vue';

import DATA from '../common/data.js';
import client from '../common/client';
import {isLogin, isOnline, skipToLoginPage} from '../util/helper';
import {store} from '../util/store';
import SubmitDialog from '../components/NewSubmitDialog.vue';
import {CrsTaxpayerType, InvoiceAmount} from '../pages/data/order';
import {
    metaInfo, baseInfo, serviceContent, advantage, materials,
    problem, intro, taxpayerTypeDataSource, invoiceAmountDataSource,
    yearDatasource
} from './data/bkp';

export default {
    components: {
        CloudLayout,
        ProductNav,
        ProductBuy,
        ProductIntro,
        SubmitDialog,
        VerifyUserPhone
    },
    metaInfo,
    data() {
        return {
            showSubmitDialog: false,
            // eslint-disable-next-line
            bookInfoDesc: '企业支付不到一个人的成本，就可以享受到全国专业的服务；服务标准、定价公开透明、信息安全保密、服务进度透明、实时在线可查；覆盖全国主要区域，满足不同类型的企业需求，帮您轻松完成企业财务税务管理',
            baseInfo,
            typeDatasource: [
                {
                    text: '零申报',
                    value: 'zero'
                },
                {
                    text: '小规模',
                    value: 'small'
                },
                {
                    text: '一般纳税人',
                    value: 'normal'
                }
            ],
            typeSelected: 'zero',
            smallMoneyDatasource: [
                {
                    text: '0-120万元',
                    value: 'small'
                },
                {
                    text: '120-300万元',
                    value: 'normal'
                },
                {
                    text: '300-700万元',
                    value: 'large'
                }
            ],
            moneySelected: 'small',
            normalMoneyDatasource: [
                {
                    text: '0-300万元',
                    value: 'small'
                },
                {
                    text: '300-700万元',
                    value: 'normal'
                },
                {
                    text: '700-2000万元',
                    value: 'large'
                }
            ],
            yearDatasource,
            yearSelected: 1,
            selectItem: DATA.productData[0],
            intro,
            advantage,
            materials,
            problem,
            serviceContent,
            // 纳税人类型
            taxpayerTypeDataSource,
            // 年开票额
            invoiceAmountDataSource,
            serviceTimeDataSource: [
                {
                    label: '1年',
                    value: 1
                }
            ],
            selectedServiceTime: 1,
            bkpCities: [],
            nameToCode: {},
            regionDatasource: [],
            priceCache: {},
            codeToPinyin: {},
            originPriceMap: {
                // 小规模纳税人-零申报
                'SMALL_SCALE_TAXPAYER-ZERO': 1999,
                // 小规模纳税人-非零申报
                'SMALL_SCALE_TAXPAYER-SMALL': 2799,
                // 一般纳税人-零申报
                'GENERAL_TAXPAYER-ZERO': 1999,
                // 一般纳税人-非零申报
                'GENERAL_TAXPAYER-SMALL': 5999
            },
            formdata: {
                selectedRegionCode: 110100,
                selectedTaxpayerType: 'SMALL_SCALE_TAXPAYER',
                selectedInvoiceAmount: 'ZERO'
            },
            hasLogin: false,
            timer: null,
            // 打开留咨弹窗
            openPhoneDialog: false,
            userPhone: '',
            // 协议信息
            protocol: {
                href: 'https://cloud.baidu.com/doc/CBS/s/8kno0p6fi',
                text: '《百度智能云代理记账服务协议》'
            },
            // 当前时间
            currentTime: new Date(),
            // 活动下线时间
            offlineTime: new Date('2021-09-01 00:00:00'),
            adding: false
        };
    },
    computed: {
        moneyDatasource() {
            if (this.typeSelected === 'normal') {
                return this.normalMoneyDatasource;
            }
            return this.smallMoneyDatasource;
        },
        judgmentTime() {
            return this.currentTime < this.offlineTime;
        }
    },
    async created() {
        this.getUrlPara();
        this.queryPrice();
        // // 获取省市区静态数据
        let staticDataResponse = await this.getStaticData();
        if (staticDataResponse && staticDataResponse.status === 200 && staticDataResponse.data) {
            const {bkpCities, nameToCode, nameToPinyin} = staticDataResponse.data;
            let codeToPinyin = {};
            Object.keys(nameToPinyin).forEach(key => {
                codeToPinyin[nameToCode[key]] = nameToPinyin[key];
            });
            let codeToName = {};
            Object.keys(nameToCode).forEach(key => {
                codeToName[nameToCode[key]] = key;
            });
            this.bkpCities = bkpCities;
            this.nameToCode = nameToCode;
            this.codeToPinyin = codeToPinyin;
            this.codeToName = codeToName;

            this.convertRegionDataToGroupData();
        }
        // 动态获取当前时间 判断活动是否下线
        this.timer = setInterval(() => {
            if (this.offlineTime < this.currentTime) {
                // 清除定时器
                clearInterval(this.timer);
            }
            this.currentTime = new Date();
        }, 1000);
    },
    mounted() {
        isLogin().then(res => {
            this.hasLogin = res && res.result && res.result.hasLogin;
        });
    },
    beforeDestroy() {
        // 清除定时器
        clearInterval(this.timer);
    },
    methods: {
        onClose() {
            this.showSubmitDialog = false;
        },

        // 关闭留咨弹窗
        onClosePhoneDialog() {
            this.openPhoneDialog = false;
        },

        // 打开留咨弹窗
        onOpenPhoneDialog() {
            this.openPhoneDialog = true;
        },

        // 保存用户电话号码
        saveUserPhone(userPhone) {
            this.userPhone = userPhone;
        },

        // 获取省市区静态数据
        getStaticData() {
            return new Promise(resolve => {
                client.queryStaticData().then(res => {
                    resolve(res);
                });
            });
        },

        // 将省市区转化为分组数据
        convertRegionDataToGroupData() {
            let result = [];
            this.bkpCities.forEach(item => {
                let groupLabel = item.groupName;
                let options = [];
                item.groupItems.forEach(groupItem => {
                    groupItem.rowItems.forEach(rowItem => {
                        options.push({
                            label: rowItem,
                            value: parseInt(this.nameToCode[rowItem], 10)
                        });
                    });
                });
                result.push({
                    label: groupLabel,
                    options
                });
            });
            this.regionDatasource = result;
            store.setRegionDatasource(result);
            if (window.location.href.indexOf('from=require') > -1) {
                this.showSubmitDialog = true;
               const href = window.location.href.replace('from=require', '');
                window.history.pushState({}, '', href);
            }
        },

        onSelect(type, item) {
            switch (type) {
                case 'taxpayerType': {
                    if (this.formdata.selectedTaxpayerType === item) {
                        return;
                    }
                    this.formdata.selectedTaxpayerType = item;
                    break;
                }
                case 'invoiceAmount': {
                    if (this.formdata.selectedInvoiceAmount === item) {
                        return;
                    }
                    this.formdata.selectedInvoiceAmount = item;
                    break;
                }
                case 'serviceTime': {
                    if (this.selectedServiceTime === item) {
                        return;
                    }
                    this.selectedServiceTime = item;
                    break;
                }
                default: {
                    break;
                }
            }
            this.queryPrice();
        },
        onBuy() {
            if (!this.hasLogin) {
                skipToLoginPage();
            }
            else {
                this.onOpenPhoneDialog();
            }
        },
        skipToOrderPage(phone) {
            let targetOrigin = isOnline ? 'https://console.bce.baidu.com' : 'https://qasandbox.bcetest.baidu.com';
            // eslint-disable-next-line
            let targetUrl = `${targetOrigin}/cbs/#/bkp/order/submit?stepStart=2&region=${this.formdata.selectedRegionCode}&taxpayerType=${this.formdata.selectedTaxpayerType}&serviceTime=${this.selectedServiceTime}&invoiceAmount=${this.formdata.selectedInvoiceAmount}`;
            if (phone) {
                targetUrl += '&phone=' + phone;
            }
            window.open(targetUrl, '_blank');
        },
        onAsk() {
            this.showSubmitDialog = true;
        },

        // 查询价格
        queryPrice() {
            this.setOriginPrice();

            client
                .queryBkpPrice({
                    area: this.formdata.selectedRegionCode,
                    taxpayerType: this.getTaxpayerTypeTextFromValue(this.formdata.selectedTaxpayerType),
                    invoiceAmount: this.formdata.selectedInvoiceAmount
                })
                .then(res => {
                    if (res.status === 200 && res.data) {
                        this.baseInfo.price = res.data.price + '元';
                    }
                });
        },

        getTaxpayerTypeTextFromValue(val) {
            let index = this.taxpayerTypeDataSource.findIndex(item => item.value === val);
            return index > -1 ? this.taxpayerTypeDataSource[index].label : '';
        },

        // 设置商品原价
        setOriginPrice() {
            let key = `${this.formdata.selectedTaxpayerType}-${this.formdata.selectedInvoiceAmount}`;
            this.baseInfo.originPrice = this.originPriceMap[key] + '元/年';
        },

        // 监听地区发生变化
        onRegionChange() {
            this.queryPrice();
        },

        // 获取url的query
        getUrlPara() {
            // 参数与console购买页保持一致
            // 服务地区：area【中文】   纳税人类型：taxpayerType【中文】   年开票额：invoiceAmount【中文】
            const {area, taxpayerType, invoiceAmount} = this.$route.query;
            if (this.isInRegionDatasource(this.regionDatasource, this.nameToCode[area])) {
                this.formdata.selectedRegionCode = +this.nameToCode[area];
            }
            if (this.isInTextDatasource(taxpayerTypeDataSource, taxpayerType)) {
                this.formdata.selectedTaxpayerType = taxpayerType;
            }
            if (this.isInTextDatasource(invoiceAmountDataSource, invoiceAmount)) {
                this.formdata.selectedInvoiceAmount = invoiceAmount;
            }
        },

        isInRegionDatasource(regionDatasource, regionCode) {
            for (let i = 0; i < regionDatasource.length; i++) {
                for (let k = 0; k < regionDatasource[i].options.length; k++) {
                    if (+regionDatasource[i].options[k].value === +regionCode) {
                        return true;
                    }
                }
            }
            return false;
        },

        isInTextDatasource(datasource, data) {
            for (let i = 0; i < datasource.length; i++) {
                if (data === datasource[i].value) {
                    return true;
                }
            }
            return false;
        },

        // 获取代金券所需要的 flavor 参数
        getBkpCouponFlavorList(options = {}) {
            const {region, taxpayerType, invoiceAmount} = options;
            return [
                {
                    name: 'productType',
                    value: 'BKP',
                    scale: 1
                },
                {
                    name: 'area',
                    value: region,
                    scale: 1
                },
                {
                    name: 'taxpayerType',
                    value: CrsTaxpayerType[taxpayerType],
                    scale: 1
                },
                {
                    name: 'invoiceAmount',
                    value: InvoiceAmount[invoiceAmount],
                    scale: 1
                }
            ];
        },

        getFlavorRegionPinyinParam(region) {
            let codeToPinyin = this.codeToPinyin;
            // 地区拼音加上后缀
            return `${codeToPinyin[region]}_bkprys`;
        },

        getFlavorTaxpayerTypeAndInvoiceAmountText(taxpayerType, invoiceAmount) {
            let taxpayerTypeText = CrsTaxpayerType[taxpayerType];
            let invoiceAmountText = InvoiceAmount[invoiceAmount];
            return `${taxpayerTypeText}-${invoiceAmountText}`;
        },

        // 加入购物车
        addShoppingCart() {
            if (!this.hasLogin) {
                skipToLoginPage();
            }
            if (this.adding) {
                return;
            }
            let region = this.formdata.selectedRegionCode;
            let taxpayerType = this.formdata.selectedTaxpayerType;
            let invoiceAmount = this.formdata.selectedInvoiceAmount;
            let cartData = {
                serviceType: 'CBS',
                serviceName: '代理记账',
                displayName: '代理记账',
                productType: 'prepay',
                count: 1,
                extra: JSON.stringify({
                    bizType: 'BKP',
                    detail: {
                        bizType: 'BKP',
                        area: region,
                        taxpayerType: CrsTaxpayerType[taxpayerType],
                        invoiceAmount
                    }
                }),
                discountFlag: true,
                uniqueQuantity: true,
                nonModifyQuantity: true,
                pricingDetail: {
                    policy: ''
                },
                campaignId: '',
                config: {
                    serviceType: 'CBS',
                    serviceName: '代理记账',
                    count: 1,
                    duration: 1,
                    orderType: 'NEW',
                    productType: 'prepay',
                    subProductType: '',
                    region: 'global',
                    timeUnit: 'YEAR',
                    unitText: '年',
                    flavor: [
                        {
                            name: this.getFlavorRegionPinyinParam(region),
                            value: this.getFlavorTaxpayerTypeAndInvoiceAmountText(taxpayerType, invoiceAmount),
                            scale: 1
                        },
                        {
                            name: 'subServiceType',
                            value: 'bookkeeping',
                            scale: 1
                        },
                        ...this.getBkpCouponFlavorList({
                            region,
                            taxpayerType,
                            invoiceAmount
                        })
                    ]
                },
                displayConfig: [
                    {
                        key: '服务地区',
                        value: this.codeToName[region]
                    },
                    {
                        key: '纳税人类型',
                        value: CrsTaxpayerType[taxpayerType]
                    },
                    {
                        key: '年开票额',
                        value: InvoiceAmount[invoiceAmount]
                    },
                    {
                        key: '服务时长',
                        value: '1年'
                    }
                ]
            };
            this.adding = true;
            client.addShoppingCart(cartData).then((res) => {
                if (res && res.data && res.data.success) {
                    // window.shoppingCart.showSuccessTip();
                    window.shoppingCart.setup();
                    Message({
                        type: 'success',
                        message: '加入购物车成功',
                        offset: 60
                    });
                    this.adding = false;
                } else {
                    Message({
                        type: 'error',
                        message: '加入购物车失败',
                        offset: 60
                    });
                    this.adding = false;
                }
            });
        }
    }
};
</script>

<style lang="less">
.book-intro-title {
    background-image: url(../assets/book_title_bac.png);
}
.book-intro-des {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #191c3d;
    opacity: 0.6;
    margin: 10px auto 48px;
    text-align: center;
    width: 816px;
}
.book-intro {
    width: 608px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto 39px;
    .book-intro-item {
        width: 96px;
    }
    img {
        width: 96px;
        height: 96px;
        display: block;
    }
    p {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 22px;
        color: #191c3d;
        opacity: 0.8;
        height: 22px;
        text-align: center;
        margin-top: 16px;
    }
}
.process-content {
    .process-icon {
        display: block;
        width: 833px;
        height: 227px;
        margin: 20px auto 40px;
    }
}
.book-advantage {
    width: 814px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 20px auto 14px;
    .book-advantage-item {
        width: 391px;
        height: 109px;
        background: #ffffff;
        box-shadow: 0px 0px 10px rgba(13, 78, 255, 0.16);
        padding: 16px;
        margin-bottom: 30px;
        img {
            width: 40px;
            height: 40px;
            float: left;
        }
        .book-advantage-text {
            margin-left: 50px;
            h4 {
                height: 25px;
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 25px;
                color: #191c3d;
            }
            p {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191c3d;
                opacity: 0.65;
            }
        }
    }
}
.book-materials {
    width: 815px;
    margin: 26px auto 50px;
    display: flex;
    justify-content: space-between;
    .book-advantage-item {
        position: relative;
        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 260px;
            height: 58px;
        }
        h4 {
            width: 260px;
            height: 58px;
            padding-top: 17px;
            padding-left: 10px;
            position: relative;
            z-index: 10;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 25px;
            color: #ffffff;
        }
        .materials-text {
            height: 69px;
            border: 1px solid #d8d8d8;
            border-top: none;
            padding-top: 8px;
            padding-left: 23px;
            p {
                height: 20px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191c3d;
                opacity: 0.8;
                position: relative;
            }
            p:before {
                content: '';
                position: absolute;
                left: -10px;
                top: 6px;
                width: 6px;
                height: 6px;
                background: #fd6c41;
                display: block;
                border-radius: 50%;
            }
        }
    }
}

.book-keeping-container {
    .el-select .el-input.is-focus .el-input__inner {
        border-color: #2468f2;
    }

    .el-select .el-input__inner:focus {
        border-color: #2468f2;
    }

    .el-dialog {
        border-radius: 10px;

        .el-dialog__header {
            border-bottom: 1px solid #f2f2f2;
            padding-bottom: 20px;

            .el-dialog__title {
                font-size: 16px;
                color: #000;
                font-weight: bold;
            }
        }

        .el-dialog__body {
            .el-form-item__label {
                color: #000;
            }
        }

        .tip-row {
            font-size: 14px;
            color: #666;
            text-align: center;
        }

        .protocol-row {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 6px;

            span {
                margin-left: 10px;
            }

            .protocol-link {
                color: #2468f2;
            }
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #2468f2;
            border-color: #2468f2;
        }

        .el-form-item {
            margin-bottom: 15px;
        }

        .form-content {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .el-input__inner {
                width: 270px;
            }

            .get-code-btn {
                white-space: nowrap;
                border: 1px solid #dcdfe6;
                box-sizing: border-box;
                height: 36px;
                line-height: 36px;
                border-radius: 4px;
                font-size: 12px;
                width: 140px;
                text-align: center;
                user-select: none;
                cursor: pointer;
            }
        }

        .el-input__inner:active {
            border-color: #2468f2;
        }

        .btns-container {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;

            .el-button {
                width: 120px;

                &:first-child {
                    margin-right: 20px;
                }
            }

            .cancel-btn {
                &:hover {
                    color: #666;
                    background-color: transparent;
                    border-color: #dcdfe6;
                }
            }

            .el-button--primary {
                background-color: #2468f2;
                border-color: #2468f2;
            }
        }
    }

    .form-activity-content {
        font-family: PingFang SC;
        font-size: 12px;
        color: #ef2323;
        line-height: 31px;
    }
    .product-buy-container {
        height: 550px;
    }
}

.book-content {
    display: flex;
    justify-content: space-between;
    padding: 27px 50px 33px;
    .book-content-item {
        display: flex;
        margin-bottom: 16px;
        align-items: flex-start;
    }
    .bk-text {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #1b1e3f;
        letter-spacing: 0;
        font-weight: 400;
        width: 320px;
    }
    .bk-icon {
        background: url('../assets/book_service_icon.png') no-repeat;
        width: 22px;
        height: 22px;
        background-size: cover;
        margin-right: 12px;
    }
    .book-content-img {
        width: 410px;
        height: 348px;
        background: url('../assets/book_service_content.png') no-repeat;
        background-size: cover;
    }
}
</style>
